import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import Updatess from './updates';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    history: false,
    fullWidth: true,
    maxWidth: 'xl',
    create: 'true',
    data: [],
  };

  componentDidMount() {
    this.getHistory();
  }

  componentDidUpdate(props) {
    if (props.customerId != this.props.customerId) {
      this.getHistory();
    }
  }

  getHistory() {
    let context = this;
    let statementId = this.props.customerId;
    $.ajax({
      type: 'POST',
      data: { 'statementId': statementId },
      url: Server() + 'statement/followuphistory.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
        } catch (e) {
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!')
      }
    });
  }

  add() {
    this.setState({ open: true });
    this.props.handleCloses();
  }

  closeDialog() {
    this.props.handleCloses();
  }

  render() {
    let i = 0;
    const { classes } = this.props;
    let dueDate = this.state.dueDate;
    let comments = this.state.comments;
    return (
      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.props.openUpdates} onClose={ () => { this.props.handleCloses() }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Follow-by and Comments and Due-date</DialogTitle>
          <DialogContent>
            <table id='table' width="100%">
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Id</center></th>
                <th id='th'><center>Due Date</center></th>
                <th id='th'><center>Followed By</center></th>
                <th id='th'><center>Comments</center></th>
                <th id='th'><center>Time</center></th>
              </tr>
              { this.state.data.map((x) => {
                  i++;
                  return(
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.statement_id}</center></td>
                      <td><center>{x.due_date}</center></td>
                      <td><center>{x.follower_name}</center></td>
                      <td><center>{x.comments}</center></td>
                      <td><center>{x.timestamp}</center></td>
                    </tr>
                  )
                })
              }
            </table>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.add.bind(this)} color="primary">
              Add
            </Button>
            <Button onClick={this.closeDialog.bind(this)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Updatess openUpdates={this.state.open} data={this.props.data}
          customerId={this.props.customerId} statementId={this.props.statementId}
          getToday={this.props.getToday} close={ () => { this.setState({ open: false }) } }
          update={this.props.update} getHistory={this.getHistory.bind(this)} />
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
